import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "app/reducers/auth";
import NavBarLogo from "app/components/atoms/NavBarLogo/NavBarLogo";
import "./NavBar.scss";

function NavBar({ authenticated, isBeta }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.auth.user); //
  const [openProfile, setOpenProfile] = useState(false);
  const profileRef = useRef(null);


   // Close profile when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setOpenProfile(false);
      }
    };

    if (openProfile) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openProfile]);


  const handleLogout = async () => {
    dispatch(logoutUser());
    navigate("/");
  };

  const capitalizeAfterDots = (email) => {
    const str = email?.split('@')[0] || '';
    return str?.replace(/(^|\.)(.)/g, (match, prefix, letter) => prefix + letter.toUpperCase()) || '';
  };

  const formatUserGroup = (group) => {
  const firstWord = group?.split('_')[0] || '';
  return firstWord.charAt(0).toUpperCase() + firstWord.slice(1) + ' group';
};



  return (
    <header className="nav-bar">
      <Link to="/" alt="Welcome | Nine Publishing Prez Hub">
        <div className="nav-bar__logo">
          <NavBarLogo />
          {isBeta && (
            <div className="nav-bar__beta-notice">Presentation Hub</div>
          )}
        </div>
      </Link>
      {authenticated && (
        <div className="nav-bar__user" ref={profileRef}>
          <div className="user-icon" onClick={() => setOpenProfile(!openProfile)}>
            <span className="name" >{capitalizeAfterDots(user.email)}</span>
            <svg height="1em" width="1em" aria-hidden="true" focusable="false">
              <use xlinkHref="#icon-account" />
            </svg>
          </div>

          {openProfile &&
            <div className="sub-holder">
              <span className="u-email">{user?.email}</span>
              <span className="u-group">{formatUserGroup(user?.group)}</span>
              <button className="nav-bar__user__logout" onClick={handleLogout}>
                <span>Logout</span>
              </button>
            </div>
          }
        </div>
      )}
    </header>
  );
}

export default NavBar;
